import { IProductId } from '@/services/product';
import messages from '../messages';

export default function(
  this: any,
  id: IProductId,
  name: string,
): Promise<false | string> {
  const { commit, dispatch } = (this as any).$store;

  return new Promise(resolve => {
    commit('dialog/CREATE', {
      title: 'Clone product?',
      content: this.$formatMessage(
        messages.PRODUCT_CLONE_ASK,
        name,
      ),
      compact: true,
      buttons: [{
        text: 'No, don\'t clone',
        click: (dialog: any) => {
          resolve(false);
          dialog.close();
        },
      }, {
        text: 'Yes, clone',
        click: (dialog: any) => {
          commit('loader/ADD', {
            title: this.$formatMessage(
              messages.PRODUCT_CLONE_CONFIRM,
              name,
            ),
            promise: dispatch('product/clone', id)
              .then((cloneId: string) => {
                resolve(cloneId);
                dialog.close();
              }, () => {
              commit('dialog/CREATE', {
                title: 'Error :(',
                content: messages.ERROR_PRODUCT_CLONE,
                compact: true,
                buttons: [{
                  text: 'Close',
                  click: (subDialog: any) => subDialog.close(),
                }],
              });
            }),
          });
        },
      }],
    });
  });
}
